export const SETTING_POINT_COLLECTION_VALIDATION = {
    total_point: {
        required: 'Nilai point wajib diisi',
    },
    min_transaction: {
        required: 'Minimal order wajib diisi',
    },
    max_amount: {
        required: 'Maximal point per order wajib diisi',
    },
}
